<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
            <div class="header-body">
                <div class="row align-items-center py-4">
                    <div class="col-lg-4 col-4">
                    <h2>Holdings</h2>
                    </div>
                    <div class="col-lg-8 col-8 text-right">
                        <!-- <form @submit.prevent="" class="d-inline-block justify-content-center headSearch mr-2">
                            <i @click="searchInventory()"  class="fas fa-search active cursor-pointer" aria-hidden="true"></i>
                            <input v-on:keyup.enter="searchInventory" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm" type="text" placeholder="Search Inventory" aria-label="Search">
                            <i v-if="searchValue" @click="clearInventory()" class="fas fa-times-circle cursor-pointer"></i>
                        </form> -->
                        <!-- <div><span class="time">Last Holding File Uploaded date: <i class="fas fa-clock"></i> <time v-text="invUploadTime"></time> </span></div> -->
                        <!-- <button @click="openImportInventoryModal()" type="button" class="btn btn-warning rounded"><i class="fas fa-file"></i> IMPORT HOLDINGS</button> -->
                        <div class="dropdown">
                          <button :disabled="invUploadStatus == 'INPROGRESS' "  class="btn btn-warning rounded dropdown-toggle ml-2 mt-0" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <div v-if="invUploadStatus == 'INPROGRESS'" style="color:black">
                              <i class="fa fa-spinner fa-spin"></i>  IMPORTING..
                            </div> 
                            <div v-if="!invUploadStatus">
                              <i class="fas fa-upload"></i>  IMPORT
                            </div>  
                          </button>
                          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <a class="dropdown-item cursor-pointer" @click="openImportInventoryModal()">HOLDINGS</a>
                            <!-- <a class="dropdown-item cursor-pointer" @click="openPositionsModal()">POSITIONS</a> -->
                            <!-- <a class="dropdown-item cursor-pointer" @click="openInventoryCostModal()">INVENTORY COST</a> -->
                            <a class="dropdown-item cursor-pointer" @click="openInvAccHoldingModal()">INVENTORY ACCOUNT HOLDINGS</a>
                          </div>
                        </div>
                        <button @click="openAddInvModal()" type="button" class="btn btn-success rounded"><i class="fas fa-user-plus"></i> ADD NEW</button>              
                    </div>
                </div>                
            </div>
            </div>
        </div>
        <div class="container-fluid mt--6 dashboard" >
            <div class="row">
                 <div class="col-xl-12">                  
                    <div class="card vh-75" id="scroll">
                      <div class="tabHeader">
                        <h4>Imported Holding</h4>
                        <div class="summary-wrap">
                          <div class="opn-wrap">
                            <a href="#">
                              {{inventoryStatus.inventoryCount}} Holding<span>Completed</span>  
                              <router-link to="/ims/ims-inventory">                       
                                <button type="submit" class="btn btn-primary my-2">GO <i aria-hidden="true" class="fa fa-arrow-circle-right"></i></button>
                              </router-link>
                            </a>
                          </div>
                          <div class="opn-wrap">
                            <a href="#">
                              {{inventoryStatus.errorInventoryCount}} Holding<span class="text-danger">Error</span>  
                              <router-link to="/ims/ims-inventory/error">
                                <button type="submit" class="btn btn-danger my-2">GO <i aria-hidden="true" class="fa fa-arrow-circle-right"></i></button>
                              </router-link>  
                            </a>
                          </div>
                        </div>
                      </div>
                      <div class="innerTab">
                        <router-link to="/ims/ims-inventory" class="inv-btn">
                          <input @click="searchValue = ''" v-bind:class="{ 'btn-primary': $route.name =='imsInventoryList' }" class="btn btn-secondary rounded" type="button" value="COMPLETED">
                        </router-link>
                        <router-link to="/ims/ims-inventory/error"  class="inv-btn">
                          <input @click="searchValue = ''" v-bind:class="{ 'btn-primary': $route.name =='imsInventoryErrorList' }" class="btn btn-secondary rounded" type="submit" value="ERRORS">   
                        </router-link>
                        <!-- <router-link to="/ims/ims-inventory/inventory-holding"  class="inv-btn">
                          <input @click="searchValue = ''" v-bind:class="{ 'btn-primary': $route.name =='ImsInventoryHoldingList' }" class="btn btn-secondary rounded" type="submit" value="INVENTORY HOLDINGS">   
                        </router-link> -->
                      </div>
                      <router-view></router-view>
                    </div>
                    </div>
            </div>
        </div> 
        <importinventory v-if="importInventoryModal" v-bind:moduleName="'IMS'" @close="closeImportInventoryModal()" />
        <importinvacct v-if="importInventoryAccModal" v-bind:moduleName="'IMS'" @close="closeImportInventoryModal()" />
        <addNewInventory v-if="addInvModalOpen" v-bind:selectedInventory="{}" v-bind:mode="'ADD'" @close="closeAddInvModal()" />
        <ImportPosition v-if="importPositionsModal"  @close="openPositionsModal()" />
        <ImportInventoryCost v-if="importInventoryCostModal"  @close="openInventoryCostModal()" />
    </div>    
</template>
<script>

import config from "@/config";
import authService from "@/authService";
import importinventory from "./ImsImportInventoryModal";
import addNewInventory from "./ImsAddInventoryModal"
import importinvacct  from "./ImsImportInventoryAccountModal"
import ImportPosition  from "./ImsImportPositionModal"
import ImportInventoryCost from "./ImsInventoryCostModal"
export default {
  name: "imsinventoryList",
  components :{
      importinventory,
      addNewInventory,
      importinvacct,
      ImportPosition,
      ImportInventoryCost
  },
  data() {
    return {
        accessToken:null,
        loading : false,
        searchValue : "",
        inventoryStatus : {},
        importInventoryModal : false,
        importInventoryAccModal : false,
        importPositionsModal : false,
        importInventoryCostModal : false,
        addInvModalOpen : false,
        invUploadTime : null,
        invUploadStatus : localStorage.getItem("INVUPLOADSTATUS")
    };
  },
  methods: {
    openInventoryCostModal(){
      this.importInventoryCostModal = !this.importInventoryCostModal;
    },
    openPositionsModal(){
      this.importPositionsModal = !this.importPositionsModal;
    },
    openImportInventoryModal(){
        this.importInventoryModal = true;
    }, 
    openInvAccHoldingModal(){
        this.importInventoryAccModal = true;
    },
    openAddInvModal(){
      this.addInvModalOpen = true;
    }, 
    closeImportInventoryModal(){
      this.importInventoryModal = false;
      this.importInventoryAccModal = false;
      this.getInventoryStatus();
      this.invUploadStatus = localStorage.getItem("INVUPLOADSTATUS");


    }, 
    closeAddInvModal(){
      this.addInvModalOpen = false;
    },
    getInventoryStatus(){
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlBidSide +
            "/inventory/count",
            auth
        )
        .then(result => {
          this.inventoryStatus = result.data;
        }).catch(() => this.loading = false);
    },
    getRecentFileUploadeddate(){
       const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlBidSide +
            "/inventory/recent-upload-date",
            auth
        )
        .then(result => {
          if(result.data){
            this.invUploadTime = this.moment(result.data).format('MMMM Do YYYY, h:mm:ss a') 
          }else{
            this.invUploadTime = "N/A"
          }
        }).catch(() => this.loading = false);
    }
    // searchInventory(){
    //   if(this.$route.name =='imsInventoryList'){
    //     this.$root.$emit("searchInventoryCompleted",{searchValue:this.searchValue});
    //   }
    //   if(this.$route.name =='imsInventoryErrorList'){
    //     this.$root.$emit("searchInventoryError",{searchValue:this.searchValue});
    //   }
    // },
    // clearInventory(){
    //   if(this.$route.name =='imsInventoryList'){
    //     this.$root.$emit("searchInventoryCompleted",{searchValue:""});
    //   }
    //   if(this.$route.name =='imsInventoryErrorList'){
    //     this.$root.$emit("searchInventoryError",{searchValue:""});
    //   }
    // }
   
  },
  mounted() {
    this.getInventoryStatus();
    //this.getRecentFileUploadeddate();
    this.$root.$on("invadded", () => {
        this.getInventoryStatus(); 
    });
    this.$root.$on("INVUPLOADCOMPLETED", () => {
      this.invUploadStatus = null;
    });
  }
};
</script>
<style scoped>
  .inv-btn{
    float: left;
    margin-left: 5px;
  }
</style>